module.exports = __webpack_public_path__ + "img/month_7_icon.1c4983fd.png";